import { BlockMapBuilder, ContentBlock, EditorState, Modifier, genKey } from "draft-js";
import { List, Map } from "immutable";

/**
 * https://github.com/facebook/draft-js/issues/543#issuecomment-234807541
 * @param {EditorState} editorState
 * @param {String}      blockType
 * @param {Object}      data
 */
export default function insertAtomicBlock(editorState, blockType, data) {
  const contentState = editorState.getCurrentContent();
  const selectionState = editorState.getSelection();

  const afterRemoval = Modifier.removeRange(contentState, selectionState, "backward");
  const targetSelection = afterRemoval.getSelectionAfter();
  const afterSplit = Modifier.splitBlock(afterRemoval, targetSelection);
  const insertionTarget = afterSplit.getSelectionAfter();

  const insertingContentBlock = new ContentBlock({
    key: genKey(),
    type: "atomic",
    text: "",
    characterList: List(),
    data: new Map({
      ...data,
      blockType,
    }),
  });

  const emptyUnstyledBlock = new ContentBlock({
    key: genKey(),
    type: "unstyled",
    text: "",
    characterList: List(),
  });

  const afterReplace = Modifier.replaceWithFragment(
    Modifier.setBlockType(afterSplit, insertionTarget, "atomic"),
    insertionTarget,
    BlockMapBuilder.createFromArray([insertingContentBlock, emptyUnstyledBlock]),
  );

  const newContent = afterReplace.merge({
    selectionBefore: selectionState,
    selectionAfter: afterReplace.getSelectionAfter().set("hasFocus", true),
  });

  return EditorState.push(editorState, newContent, "insert-fragment");
}
